module.exports = __webpack_public_path__ + "img/verify-code.82ad4ceb.jpg";